// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__1OHuF","buttonWidth":"Button_buttonWidth__3t-KV"};